<template>
    <v-card class="grey lighten-4">
        <v-toolbar dense dark color="light-blue darken-4">
            <v-toolbar-title class="my-list-title"><v-icon>mdi-bacteria</v-icon> &nbsp; Desparasitación</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-tooltip bottom :disabled="bEdit">
                    <template v-slot:activator="{ on }">
                        <v-btn :disabled="bEdit" text @click="onEditDesp"  v-on="on">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>Editar desparasitación</span>
                </v-tooltip>
                <v-tooltip bottom v-if="!bMaximized">
                    <template v-slot:activator="{ on }">
                        <v-btn text @click="onMaximize" v-on="on">
                            <v-icon>mdi-window-maximize</v-icon>
                        </v-btn>
                    </template>
                    <span>Maximizar</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on }">
                        <v-btn text @click="onMinimize" v-on="on">
                            <v-icon>mdi-window-restore</v-icon>
                        </v-btn>
                    </template>
                    <span>Minimiz. tamaño</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn text @click="onClose" v-on="on" :disabled="bEdit">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Cerrar</span>
                </v-tooltip>
            </v-toolbar-items>

            <!-- Menú lateral para dispositivos con ventanas chicas: -->
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" class="hidden-md-and-up">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list color="grey lighten-4">
                    <v-list-item :disabled="bEdit" @click="onEditDesp">
                        <v-list-item-title>
                            <v-icon color="light-blue darken-4">mdi-edit</v-icon>&nbsp; Editar Desparasitación
                        </v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item :disabled="bEdit" @click="onClose">
                        <v-list-item-title>
                            <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>

        <v-card-text>
            <v-container fluid grid-list-md>
                <v-row>
                    <v-col cols="12">
                        <img-viewer :imgSrc = despImg></img-viewer>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            dense
                            prepend-icon="mdi-camera"
                            label="Archivo"
                            type="text"
                            v-model="fileName"
                            readonly
                            color="light-blue darken-4"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            dense
                            prepend-icon="mdi-medication"
                            label="Medicamento"
                            type="text"
                            v-model="drug"
                            color="light-blue darken-4"
                            :readonly="!bEdit"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-menu
                            v-model="bApplicationDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            :disabled="!bEdit"
                        >
                            <template
                                v-slot:activator="{
                                    on,
                                }"
                            >
                                <v-text-field
                                    dense
                                    color="light-blue darken-4"
                                    v-model="applicationDate"
                                    label="Fecha de aplicación"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                color="light-blue darken-2"
                                v-model="applicationDate"
                                @input="bApplicationDate = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="3">
                        <v-menu
                            v-model="bExpirationDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            :disabled="!bEdit"
                        >
                            <template
                                v-slot:activator="{
                                    on,
                                }"
                            >
                                <v-text-field
                                    dense
                                    color="light-blue darken-4"
                                    v-model="expirationDate"
                                    label="Fecha de expiración"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                color="light-blue darken-2"
                                v-model="expirationDate"
                                @input="bExpirationDate = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            dense
                            prepend-icon="mdi-decagram-outline"
                            label="Marca"
                            type="text"
                            v-model="brand"
                            color="light-blue darken-4"
                            :readonly="!bEdit"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            dense
                            prepend-icon="mdi-barcode"
                            label="Lote"
                            type="text"
                            v-model="lot"
                            color="light-blue darken-4"
                            :readonly="!bEdit"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <!-- Modal para informar que hay un error en los datos de la desparasitación: *********************************** -->
                <v-layout row justify-center>
                    <v-dialog
                        v-model="bDlgDespError"
                        persistent
                        :width="errorModalWidth"
                    >
                        <v-card class="grey lighten-4">
                            <v-toolbar dense color="orange darken-4" dark flat>
                                <v-toolbar-title class="my-list-title"
                                    >Error en la edición de la desparasitación</v-toolbar-title
                                >
                                <v-spacer></v-spacer>
                                <v-icon>mdi-alert-circle-outline</v-icon>
                            </v-toolbar>
                            <v-card-title>
                                <v-container>
                                    <v-layout row>
                                        <v-flex xs12 class="d-flex justify-center">
                                            <v-icon large color="orange darken-2"
                                                >mdi-alert</v-icon
                                            >
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex
                                            xs12
                                            class="d-flex justify-center text-center"
                                            >{{ errorMessage }}</v-flex
                                        >
                                    </v-layout>
                                </v-container>
                            </v-card-title>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="teal darken-3"
                                    class="text-none"
                                    text
                                    @click="bDlgDespError = false"
                                    >OK</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-layout>
                <!-- Termina modal para informar que hay un error en la edición de la desparasitación *********************************** -->
            </v-container>
        </v-card-text>
        <v-card-actions v-if="bEdit">
            <v-spacer></v-spacer>
            <v-btn
                color="teal darken-3"
                class="text-none"
                text
                @click="onSave"
                >OK
            </v-btn>
            <v-btn
                color="pink darken-1"
                class="text-none"
                text
                @click="onClose"
                >Cancelar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import ImgViewer from '@/components/ImgViewer.vue';

export default {
    data() {
        return {
            bMaximized: false,
            bEdit: false,
            bInvalidData: false,
            errorMessage: '',

            //Variables para los text-fields:
            drug: '',
            applicationDate: '',
            expirationDate: '',
            brand: '',
            lot: '',

            //Variables para conservar los valores originales en caso de cancelación de edición:
            init_drug: '',
            init_applicationDate: '',
            init_expirationDate: '',
            init_brand: '',
            init_lot: '',

            bApplicationDate: false,
            bExpirationDate: false,
            bDlgDespError: false,
        }
    },
    props: {
        desparasitacionid: Number,
        mascotaid: Number,
        fileName: String,
        fileType: String,
        fileDownloadUri: String,
        medicamento: String,
        fechaAplicacion: String,
        fechaExpiracion: String,
        marca: String,
        lote: String,
        registro: String,
    },

    components: {
        ImgViewer,
    },

    created(){
        if (this.fileDownloadUri === "")
        {
            this.despImg = require('@/assets/no-photo.png');
        }
        else
        {
            const imgInfo = {
                fileName: this.fileName,
                fileType: this.fileType,
                fileDownloadUri: this.fileDownloadUri,
            }
            console.log("fileDownloadURI = ", this.fileDownloadUri);
            console.log("imgInfo = ", imgInfo);
            this.$store.dispatch('getDespImg', imgInfo);
        }

        //Se llenan los valores de reset con los valores de los props:
        this.init_drug = this.medicamento;
        this.init_applicationDate = this.fechaAplicacion;
        this.init_expirationDate = this.fechaExpiracion;
        this.init_brand = this.marca;
        this.init_lot = this.lote;

        //Se llenan los valores de los text fields con los valores de reset:
        this.resetValues();
    },

    methods:{

        resetValues(){
            this.drug = this.init_drug;
            this.applicationDate = this.init_applicationDate;
            this.expirationDate = this.init_expirationDate;
            this.brand = this.init_brand;
            this.lot = this.init_lot;
        },
        onMaximize(){
            this.bMaximized = true;
            this.despDlgWidth = "100%";
        },
        onMinimize(){
            this.bMaximized = false;
            this.despDlgWidth = "60%";
        },
        onClose(){
            this.showDespDlg = false;
            this.despDlgWidth = "60%";
        },
        onEditDesp(){
            this.bEdit = true;
        },
        onCancel(){
            this.resetValues();
            this.bEdit = false;
        },
        onSave(){
            var bDataOK = false;

            //Se validan los datos:

            if (this.drug === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'Introduzca el nombre del medicamento.';
            }
            else if (this.applicationDate === '')//Pendiente, checar cuál va a ser el valor inicial de registration date cuando se edita un medicamento por primera vez...
            {
                this.bInvalidData = true;
                this.errorMessage = 'Seleccione una fecha de aplicación válida.'
            }
            else if (this.expirationDate === '')//Pendiente, checar cuál va a ser el valor inicial de registration date cuando se edita un medicamento por primera vez...
            {
                this.bInvalidData = true;
                this.errorMessage = 'Seleccione una fecha de expiración válida.'
            }
            else if (this.brand === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'Introduzca la marca del medicamento.';
            }
            else if (this.lot === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'Introduzca el lote del medicamento.';
            }
            else
            {
                bDataOK = true;
            }

            if (bDataOK)
            {
                this.init_drug = this.drug;
                this.init_fechaAplicacion = this.applicationDate;
                this.init_fechaExpiracion = this.expirationDate;
                this.init_marca = this.brand;
                this.init_lote = this.lot;

                const despToEdit = {
                    desparasitacionid: this.desparasitacionid,
                    medicamento: this.drug,
                    filedownloaduri: this.fileDownloadUri,
                    registro: this.registro,
                    aplicacion: this.applicationDate,
                    expiracion: this.expirationDate,
                    marca: this.brand,
                    lote: this.lot,
                    mascotaid: this.mascotaid,
                    error: 0
                }
                console.log("DespToEdit = ", despToEdit);
                this.$store.dispatch('saveDeworming', despToEdit)
                this.bEdit = false;
            }
            else
            {
                this.bDlgDespError = true;
            }
        },
    },

    computed:{
        ...mapGetters([
            'waitCursor'
        ]),

        showDespDlg: {
            get() {
                return this.$store.getters.showDespDlg;
            },
            set(showDespDlg) {
                this.$store.dispatch('updateShowDespDlg', showDespDlg);
            }
        },

        despImg: {
            get() {
                return this.$store.getters.despImg;
            },
            set(despImg) {
                this.$store.dispatch('updateDespImg', despImg);
            }
        },

        despDlgWidth: {
            get() {
                return this.$store.getters.despDlgWidth;
            },
            set(despDlgWidth) {
                this.$store.dispatch('updateDespDlgWidth', despDlgWidth);
            }
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },
    },
}
</script>
